import React, { Component } from "react";

export default class Liising extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
    };
  }


  addInfo = () => {
const {data} = this.props;
    if (data.power_kw === 260 && data.eripakkumine === "115000.00") {

      return (
        <p>
          SEB liisinguintress 1,65% + 6k Euribor *Liisingu igakuine kuumakse on
          1 207€. 60 kuulise lepingu korral ja krediidi kulukuse esialgne määr
          3,6% aastas järgmistel kasutusrendi tüüpi liisingfinantseerimise
          näidistingimustel: sõiduk hinnaga 115 000€ koos käibemaksuga;
          sissemakse 23 000€ eurot (20% sõiduki hinnast); jääkväärtus 25%
          sõiduki hinnast; kasutusse võetav krediidisumma koos käibemaksuga 92
          000€ ; intressimäär 3.6% aastas krediidijäägilt (intressimäär koosneb
          6 kuu euriborist ja marginaalist 1,65%; 11.11.2025 seisuga oli kuue
          kuu euribor 2.124%; lepingus fikseeritud euribor võib muutuda iga kuue
          kuu järel, marginaal on fikseeritud lepingu lõpuni); tagastamine viie
          aasta jooksul 60 igakuise annuiteetmaksena, jääkväärtus tasutakse
          liisinguperioodi lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast
          aga mitte vähem kui 225€. Kliendi makstav tagasimaksete summa on 72
          420€ ja maksete kogusumma on 125 859€.
        </p>
      );
    }
    if (data.power_kw === 346 && data.eripakkumine === "125000.00") {

      return (
        <p>
          SEB liisinguintress 1,65% + 6k Euribor *Liisingu igakuine kuumakse on
          1 321€. 60 kuulise lepingu korral ja krediidi kulukuse esialgne määr
          3,6% aastas järgmistel kasutusrendi tüüpi liisingfinantseerimise
          näidistingimustel: sõiduk hinnaga 125 000€ koos käibemaksuga;
          sissemakse 25 000€ eurot (20% sõiduki hinnast); jääkväärtus 25%
          sõiduki hinnast; kasutusse võetav krediidisumma koos käibemaksuga 100
          000€ ; intressimäär 3.6% aastas krediidijäägilt (intressimäär koosneb
          6 kuu euriborist ja marginaalist 1,65%; 11.11.2025 seisuga oli kuue
          kuu euribor 2.124%; lepingus fikseeritud euribor võib muutuda iga kuue
          kuu järel, marginaal on fikseeritud lepingu lõpuni); tagastamine viie
          aasta jooksul 60 igakuise annuiteetmaksena, jääkväärtus tasutakse
          liisinguperioodi lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast
          aga mitte vähem kui 225€. Kliendi makstav tagasimaksete summa on 79
          760 € ja maksete kogusumma on 136 801€.{" "}
        </p>
      );
    }
    if (data.power_kw === 346 && data.eripakkumine === "130000.00") {

      return (
        <p>
          SEB liisinguintress 1,65% + 6k Euribor *Liisingu igakuine kuumakse on
          1 374€. 60 kuulise lepingu korral ja krediidi kulukuse esialgne määr
          3,6% aastas järgmistel kasutusrendi tüüpi liisingfinantseerimise
          näidistingimustel: sõiduk hinnaga 130 000€ koos käibemaksuga;
          sissemakse 26 000€ eurot (20% sõiduki hinnast); jääkväärtus 25%
          sõiduki hinnast; kasutusse võetav krediidisumma koos käibemaksuga 104
          000€ ; intressimäär 3.6% aastas krediidijäägilt (intressimäär koosneb
          6 kuu euriborist ja marginaalist 1,65%; 11.11.2025 seisuga oli kuue
          kuu euribor 2.124%; lepingus fikseeritud euribor võib muutuda iga kuue
          kuu järel, marginaal on fikseeritud lepingu lõpuni); tagastamine viie
          aasta jooksul 60 igakuise annuiteetmaksena, jääkväärtus tasutakse
          liisinguperioodi lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast
          aga mitte vähem kui 225€. Kliendi makstav tagasimaksete summa on 82
          440€ ja maksete kogusumma on 142 272€.{" "}
        </p>
      );
    }
    if (data.power_kw === 382 && data.eripakkumine === "140000.00") {
 
      return (
        <p>
          SEB liisinguintress 1,65% + 6k Euribor *Liisingu igakuine kuumakse on
          1 480€. 60 kuulise lepingu korral ja krediidi kulukuse esialgne määr
          3,6% aastas järgmistel kasutusrendi tüüpi liisingfinantseerimise
          näidistingimustel: sõiduk hinnaga 140 000€ koos käibemaksuga;
          sissemakse 28 000€ eurot (20% sõiduki hinnast); jääkväärtus 25%
          sõiduki hinnast; kasutusse võetav krediidisumma koos käibemaksuga 112
          000€ ; intressimäär 3.6% aastas krediidijäägilt (intressimäär koosneb
          6 kuu euriborist ja marginaalist 1,65%; 11.11.2025 seisuga oli kuue
          kuu euribor 2.124%; lepingus fikseeritud euribor võib muutuda iga kuue
          kuu järel, marginaal on fikseeritud lepingu lõpuni); tagastamine viie
          aasta jooksul 60 igakuise annuiteetmaksena, jääkväärtus tasutakse
          liisinguperioodi lõpus; lepingu sõlmimise tasu on 1% sõidukihinnast
          aga mitte vähem kui 225€. Kliendi makstav tagasimaksete summa on 88
          800€ ja maksete kogusumma on 153 213€.{" "}
        </p>
       
      );
    }
    return " ";
  };



  addHinnaklass = () => {
const {data} = this.props;
    if (data.eripakkumine === "115000.00") {
      return (
        <>
           al. 1300 € aasta / al. 108,33 € kuu

        </>
      );
    }
    if (data.eripakkumine === "125000.00") {
      return (
        <>
al. 1450 € aasta / al. 120,83 € kuu

        </>
      );
    }
    if ( data.eripakkumine === "130000.00") {
      return (
       <>
al. 1450 € aasta / al. 120,83 € kuu
        </>
      );
    }
    if (data.eripakkumine === "140000.00") {

      return (
        <>
al. 1600 € aasta / al. 133,33 € kuu
        </>
       
      );
    }
    return " ";
  };

  render() {
    return (
      <>
        {this.addInfo()}
        <p>
          Finantsteenuse pakkuja on AS SEB Liising, tegemist on tüüpnäitega ja
          tegelikud pakutavad tingimused võivad erineda. Enne lepingu sõlmimist
          tutvuge tingimustega <a href="https://www.seb.ee/eraklient/laenud/liising" target="_blank" rel="noreferrer">www.seb.ee/liising</a> ja vajadusel konsulteerige
          pangatöötaja või meie müügikonsultandiga. Teil on õigus alati küsida
          infot liisingutingimuste kohta ja saada selgitusi nii enne
          liisingulepingu sõlmimist kui ka selle kehtivuse ajal. Meie
          müügikonsultandid aitavad teid igas küsimuses.
        </p>
        <p>
<br />
IIZI Kindlustusmaakler AS, LHV näidismakse<br /><br />
{this.addHinnaklass()}
<br />Standard Kasko – asendussõidukikindlustus ja uusväärtuskindlustus on hinnas
<br />Omavastutus  –  põhiomavastutus 300 eurot,  klaasikahjud 10% omavastutus, metsloomaga kokkupõrge põhiomavastutus, varguse ja röövi omavastutus 15%.
<br />Kindlustusperiood - 1 aasta  
<br />Kasutusala – tavakasutus                         
<br />Käesolev kindlustuspakkumine on koostatud Auto 100 poolt avaldatud kindlustushuvi alusel, eesmärgiga toetada perioodil 17.11 kuni 31.01 toimuvat Porsche sõidukite müügikampaaniat.
<br />Kui teie kindlustushuvi on sellest erinev, andke meile sellest kindlasti teada ja saame koostada teie kindlustushuvile vastava pakkumuse.

        </p>
      </>
    );
  }
}
